import { render, staticRenderFns } from "./UserChangePass.vue?vue&type=template&id=03dd3248&scoped=true&"
import script from "./UserChangePass.vue?vue&type=script&lang=js&"
export * from "./UserChangePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dd3248",
  null
  
)

export default component.exports